<template>
  <div>
    <RefreshResults
      v-if="showRefreshNotification"
      :type="'flight'"
      @clearResults="clearResults"
      @refreshSearch="refreshSearch"
    />
    <div v-else>
      <div v-if="items.length > 0">
        <div class="pt-4">
          <HiddenResultsNotification
            v-if="hiddenItemsCount > 0"
            :hiddenItemsCount="hiddenItemsCount"
          />
          <b-tabs
            v-if="tripVal !== TRIP_MULTI_CITY"
            v-model="activeTab"
            position="is-centered"
            type="is-toggle"
            id="flightSearchSwitcherTabs"
            :animated="false"
            size="is-small"
          >
            <b-tab-item
              label="Results by Schedule"
              class="fSwitcher"
              data-test="schedule_results"
            >
              <ResultsBySchedule
                :items="visibleItems"
                :formData="formData"
                @appendResults="appendResults"
                @searchTargetedAirlines="searchTargetedAirlines"
              />
            </b-tab-item>
            <b-tab-item
              label="Results by Price"
              class="fSwitcher"
              data-test="price_results"
            >
              <ResultsByPrice
                :items="visibleItems"
                :formData="formData"
                @searchTargetedAirlines="searchTargetedAirlines"
              />
            </b-tab-item>
          </b-tabs>
          <template v-else>
            <ResultsByPrice
              :items="visibleItems"
              :formData="formData"
              @searchTargetedAirlines="searchTargetedAirlines"
              class="mt-5"
              data-test="price_results"
            />
          </template>
        </div>
      </div>

      <div v-else-if="pendingSearchCount > 0">
        <div v-if="!first_selected">
          <div v-for="(result, index) in skelItems" :key="index">
            <ResultSkele />
          </div>
        </div>
      </div>

      <SearchErrorMessage
        v-if="showErrors"
        :error_id="error_id"
        :errors="errors"
        :reportable="true"
      >
        <p data-test="search-not-found" class="is-size-6">
          <strong>Something went wrong.</strong>
        </p>
        <p class="is-size-7 mb-2">
          Some search results failed to load. You can try again, or try another
          search.
        </p>
      </SearchErrorMessage>

      <b-modal
        v-model="showDetails"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        close-button-aria-label="Close"
        aria-modal
      >
        <div class="card p-3">

          <b-button
            label="Close"
            @click="closeDetails"
            type="is-info"
            expanded
            style="border-radius:0px"
            class="mb-4"

          />
          <FlightDetails
            v-if="showDetails"
            :journeys="this.$store.state.bookTravel.flightDetails.journeys"
          />
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ResultsBySchedule from "./ResultsBySchedule";
import ResultsByPrice from "./ResultsByPrice";
import bookingMixin from "@/mixins/bookingMixin";
import ResultSkele from "../../SkeletonLoaders/ResultSkele.vue";
import HiddenResultsNotification from "../HiddenResultsNotification.vue";
import RefreshResults from "@/components/BookTravel/RefreshResults.vue";
import SearchErrorMessage from "@/components/BookTravel/SearchErrorMessage.vue";
import FlightDetails from "./FlightDetails.vue";
import { mapState } from "vuex";

export default {
  name: "FlightResults",
  mixins: [bookingMixin],
  props: {
    flightSearchToResultsBus: Object,
    formData: {
      type: Object,
    },
  },
  components: {
    ResultsBySchedule,
    ResultSkele,
    HiddenResultsNotification,
    ResultsByPrice,
    RefreshResults,
    SearchErrorMessage,
    FlightDetails,
  },
  data() {
    return {
      activeTab: 0,
      showRefreshNotification: false,
      loading: false,
      loaded: false,
      errors: [],
      error_id: null,
      first_selected: false,
      skelItems: [{}, {}, {}],
      items: [],
      no_results: false,
      display_search: false,
      refreshTimer: null,
      uniqueItems: {},
      windowWidth: window.innerWidth,
      pendingSearchCount: 0,
    };
  },
  watch: {
    formData: {
      handler(newVal, prevVal) {
        this.showRefreshNotification = false;
        this.pendingSearchCount = 0;
        //this.errors = [];
        this.getData();
      },
      deep: false,
    },

    // TODO test
    showRefreshNotification(newVal, prevVal) {
      this.setSearchRecordsStatus("flight", newVal);
    },
  },
  computed: {
    ...mapState(["travellersAndTrips"]),
    hiddenItemsCount() {
      let items = this.items;

      if (items.length > 0) {
        items = items.filter((i) => {
          return !i.isVisible;
        });
      }

      return items.length;
    },
    //remove items that should be hidden based on travel policy restrictions from visible results
    visibleItems() {
      let items = this.items;

      if (items.length > 0) {
        items = items.filter((i) => {
          return i.isVisible;
        });
      }

      return items;
    },
    /*
      availLegs1(){
        return this.getLegs(0, this.filteredItems)
      },
      availLegs2(){
        if (this.tripval !== 0){
          return this.getLegs(1, this.filteredItems)
        }
        else{
          return [];
        }
      },
      */
    flightSearchLoadingStatus() {
      return this.$store.state.bookTravel.flightSearchLoadingStatus;
    },
    loc1() {
      return this.formData.loc1.code;
    },
    loc2() {
      return this.formData.loc2.code;
    },
    startDate() {
      return this.formData.startDate.date;
    },
    endDate() {
      return this.formData.endDate.date;
    },
    startTime() {
      return this.formData.startDate.time;
    },
    endTime() {
      return this.formData.endDate.time;
    },
    tripVal() {
      return this.formData.tripVal;
    },
    loadingMessage() {
      return this.pendingSearchCount > 1
        ? "Searching flights"
        : "Looking for additional flight results";
    },
    showErrors() {
      return (
        this.pendingSearchCount == 0 &&
        (this.errors.length > 0 || this.items.length == 0)
      );
    },
    showDetails: {
      get() {
        return this.$store.state.bookTravel.flightDetails.show;
      },
      set(val) {
        let details = {
          show: val,
        };

        this.$store.commit("bookTravel/SET_FLIGHT_DETAILS", details);
      },
    },
    preferredVendors() {
      return this.$globals.profile.preferredAirVendors;
    },
  },
  methods: {
    buildSearchBody(mandatoryAirlines = [], excludedAirlines = []) {
      let body;

      if (this.tripVal === this.TRIP_MULTI_CITY) {
        let itinerary = [];
        for (let row of this.formData.multiCity) {
          let leg = {
            date: {
              date: moment(row.depDate.date).format("YYYY-MM-DD"),
            },
          };

          if (row.depDate.advanced.tod !== "Anytime") {
            leg.date = this.setAdvancedDateTime(row.depDate);
            leg.date.timeWindow = 4;
          }

          if (row.fromLoc.subType === "AIRPORT") {
            leg.departureLocation = {
              airport: row.fromLoc.code,
            };
          }
          if (row.fromLoc.subType === "CITY") {
            leg.departureLocation = {
              city: row.fromLoc.cityCode,
            };
          }
          if (row.toLoc.subType === "AIRPORT") {
            leg.arrivalLocation = {
              airport: row.toLoc.code,
            };
          }
          if (row.toLoc.subType === "CITY") {
            leg.arrivalLocation = {
              city: row.toLoc.cityCode,
            };
          }
          itinerary.push(leg);
        }

        body = {
          numberOfPassengers: 1,
          numberOfResults: 200,
          itinerary: itinerary,
        };
      } else {
        let locType1 = "airport";
        let locType2 = "airport";

        if (this.formData.loc1.subType == "CITY") {
          locType1 = "city";
        }
        if (this.formData.loc2.subType == "CITY") {
          locType2 = "city";
        }

        if (this.tripVal === this.TRIP_ONE_WAY) {
          body = {
            travelerId: this.$globals.travellerProfile.id,
            applyPolicy: false,
            numberOfPassengers: 1,
            numberOfResults: 200,
            itinerary: [
              {
                departureLocation: {
                  [locType1]: this.loc1,
                },
                arrivalLocation: {
                  [locType2]: this.loc2,
                },
                date: {
                  date: moment(this.startDate).format("YYYY-MM-DD"),
                },
              },
            ],
          };
        } else if (this.tripVal === this.TRIP_ROUNDTRIP) {
          body = {
            travelerId: this.$globals.travellerProfile.id,
            applyPolicy: false,
            numberOfPassengers: 1,
            numberOfResults: 200,
            itinerary: [
              {
                departureLocation: {
                  [locType1]: this.loc1,
                },
                arrivalLocation: {
                  [locType2]: this.loc2,
                },
                date: {
                  date: moment(this.startDate).format("YYYY-MM-DD"),
                },
              },
              {
                departureLocation: {
                  [locType2]: this.loc2,
                },
                arrivalLocation: {
                  [locType1]: this.loc1,
                },
                date: {
                  date: moment(this.endDate).format("YYYY-MM-DD"),
                },
              },
            ],
          };
        }

        if (
          this.$store.getters["travellersAndTrips/getTravellers"].tripType ===
          "business"
        ) {
          body.travelPolicyId = this.$globals.travellerProfile.travelPolicyId;
          body.applyPolicy = true;
        }

        if (this.formData.startDate.advanced.tod !== "Anytime") {
          body.itinerary[0].date = this.setAdvancedDateTime(
            this.formData.startDate
          );
        }

        if (this.formData.endDate.advanced.tod !== "Anytime") {
          body.itinerary[1].date = this.setAdvancedDateTime(
            this.formData.endDate
          );
        }
      }

      if (this.formData.cabinClass) {
        body.cabinClass = this.formData.cabinClass;
      }

      if (this.isMeeting) {
        if (this.meetingInfo.meetingId !== null) {
          body.meetingId = this.meetingInfo.meetingId;
        }
      }

      // Add preferred / mandatory airlines
      if (mandatoryAirlines.length > 0) {
        body.mandatoryAirlines = mandatoryAirlines;
      }

      // Add excluded airlines
      if (excludedAirlines.length > 0) {
        body.excludedAirlines = excludedAirlines;
      }
      return body;
    },
    async getData(refresh = false) {
      this.showRefreshNotification = false; // TODO test
      this.loading = true;
      this.error = false;
      this.errors = [];
      this.items = [];

      //search for preferred airlines in parallel to primary search
      let preferredAirVendors = this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].preferredAirVendors;
      if (preferredAirVendors?.length > 0) {
        this.searchTargetedAirlines(preferredAirVendors);

        // Future feature?
        // Individual search request for every preferred vendor
        //for (let vendorCode of preferredAirVendors) {
        //this.searchTargetedAirlines([vendorCode]);
        //}
      }

      this.$store.commit("bookTravel/CLEAR_SELECTED_UNBUNDLED_JOURNEYS");

      // Exclude preferred airlines from the generic call
      let excludedAirlines = preferredAirVendors;

      let body = this.buildSearchBody([], excludedAirlines);

      this.pendingSearchCount++;

      await this.$app
        .huddleLabsServerCall("amadeus/air/search", body)
        .then((result) => {
          if (result.data && result.data.length > 0) {
            for (let item of result.data) {
              // add pricing to journeys
              if (this.tripVal !== this.TRIP_MULTI_CITY) {
                item.journeys[0].pricing = item.pricing;
                if (this.tripVal === this.TRIP_ROUNDTRIP) {
                  item.journeys[1].pricing = item.pricing;
                }
              }
              this.items.push(item);
            }

            this.finalizeItemsLoading("flight");
          } else if (result.errors) {
            //if no results, show error message returned from server
            let errors = result.errors; //Object.entries(result.errors);
            this.errors = this.errors.concat(errors);
            this.error_id = result.meta?.error_log_id;
          } else if (result.message) {
            //server error
            let errors = { title: result.message };
            this.errors = this.errors.concat(errors);
          } else {
            //else show default error message
            let errors = { title: "Search failed or no results found." };
            this.errors = this.errors.concat(errors);
          }

          this.pendingSearchCount--;
        });
    },
    //search for specific airline(s)
    async searchTargetedAirlines(targetedAirlines = []) {
      if (targetedAirlines.length < 1) {
        return;
      }

      let body = this.buildSearchBody(targetedAirlines);

      this.pendingSearchCount++;
      let result = await this.$app.huddleLabsServerCall(
        "amadeus/air/search",
        body
      );

      this.pendingSearchCount--;

      if (result.data && result.data.length > 0) {
        this.appendResults(result.data);
      } else if (result.errors) {
        //show error message returned from server
        let errors = result.errors; //Object.entries(result.errors);
        this.errors = this.errors.concat(errors);
        this.error_id = result.error_log_id;
      } else {
        //show default error message
        let errors = { title: "No results found for targeted airlines." };
        this.errors.push(errors);
      }

      this.$store.commit("bookTravel/FLIGHT_SEARCH_LOADING_STATUS", false);
    },

    //append new flight results to this.items array
    appendResults(results) {
      if (results.length) {
        //this.addSolutionKeyToJourneys(results);

        for (let i = 0; i < results.length; i++) {
          let result = results[i];

          //make sure we are not adding any duplicate results
          let found = this.items.find(
            (item) => item.uniqueKey === result.uniqueKey
          );

          if (!found) {
            // FOR SEARCH BY SCHEDULE PRICE RANGES
            if (result.journeys.length == 1) {
              //add pricing to outbound (one-way)
              result.journeys[0].pricing = result.pricing;
            } else {
              //add pricing to return (roundtrip)
              result.journeys[1].pricing = result.pricing;
            }

            //append item to items
            this.items.push(result);
          }
        }
      }

      //add to additional flight results counter
      //this.$store.commit("bookTravel/ADD_MORE_FLIGHT_RESULTS_MULTIPLE", results);
    },
    setAdvancedDateTime(obj) {
      //console.dir(obj);

      let date = {
        date: moment(obj.date).format("YYYY-MM-DD"),
        time: null,
        timeWindow: 4,
        isDeparture: obj.advanced.isDeparture, //.toString(),
      };

      if (obj.advanced.tod == "Morning") {
        date.time = "8:00";
      }

      if (obj.advanced.tod == "Afternoon") {
        date.time = "13:00";
      }

      if (obj.advanced.tod == "Evening") {
        date.time = "18:00";
      }

      if (obj.advanced.tod == "Custom") {
        date.time = moment(obj.advanced.time).format("HH:mm");
        date.timeWindow = obj.advanced.hours;
      }

      return date;
    },

    dateParse(date) {
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() > 8
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) +
        "-" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate())
      );
    },
    closeDetails() {
      this.$store.commit("bookTravel/HIDE_FLIGHT_DETAILS");
    },
  },
  async mounted() {
    // Set some constants so we can reference them in a meaningful way
    // in the search request builder and other places.
    this.TRIP_ONE_WAY = 0;
    this.TRIP_ROUNDTRIP = 1;
    this.TRIP_MULTI_CITY = 2;
    this.ARRIVAL_TIME = 1;
    this.DEPARTURE_TIME = 0;

    this.$store.commit("bookTravel/HIDE_FLIGHT_DETAILS");

    this.setSearchRecordsStatus("flight", this.showRefreshNotification);
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
    //
    this.clearBundledSelections();
    await this.getData();
  },

  beforeDestroy() {
    clearTimeout(this.refreshTimer);
  },
};
</script>

<style scoped>
.loading:after {
  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;
  -webkit-animation: ellipsis steps(4, end) 900ms infinite;
  animation: ellipsis steps(4, end) 900ms infinite;
  content: "\2026"; /* ascii code for the ellipsis character */
  width: 0px;
}

@keyframes ellipsis {
  to {
    width: 1.25em;
  }
}

@-webkit-keyframes ellipsis {
  to {
    width: 1.25em;
  }
}
</style>
